import Script from 'next/script'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'

export type OutgrowWidgetContentItem = IContentItem<{
	outgrowId: Elements.TextElement
}>

export const OutgrowWidgetBlock: Block<OutgrowWidgetContentItem> = ({
	block,
}) => {
	const outgrowId = block.elements.outgrowId || ''

	if (!outgrowId) {
		return null
	}

	return (
		<div data-kontent-element-codename="outgrow_id">
			<div
				className="op-interactive"
				data-title="Outgrow Interactive Content"
				data-url={`https://elanco588.outgrow.us/${outgrowId}?vHeight=1`}
				data-width="100%"
				id={outgrowId}
			/>
			<Script
				dangerouslySetInnerHTML={{
					__html: `
						var og_temp=document.createElement('script');
						og_temp.async=true;
						og_temp.defer=true;
						og_temp.src='//dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js';
						og_temp.onload=function(){
							initIframe('${outgrowId}');
						};
						document.querySelector('head').appendChild(og_temp);
					`,
				}}
				id={`outgrow-loader-${outgrowId}`}
				strategy="afterInteractive"
			/>
		</div>
	)
}
